import React from "react";
import GaugeChart from "react-gauge-chart";
import { Grid, Label } from "semantic-ui-react";
import { translate } from "react-i18next";

const Gauge = ({ t }) => {
  return (
    <React.Fragment>
      <Grid columns="equal" className="p-2">
        <Grid.Row>
          <Grid.Column>
            <GaugeChart
              id="gauge-chart1"
              textColor="black"
              nrOfLevels={35}
              percent={0.56}
              hideText="true"
              colors={["#63B3EB"]}
              needleColor="#63B3EB"
              needleBaseColor="#63B3EB"
            />
            <center>
              <Label className="p-gauge-blue">56%</Label>
            </center>
            <center className="p-bold-500 w3-small m-1">
              {t("gauge.order_acceptance") ||
                "Order Acceptance"}{" "}
              %
            </center>
          </Grid.Column>
          <Grid.Column>
            <GaugeChart
              id="gauge-chart2"
              textColor="black"
              nrOfLevels={35}
              percent={0.2}
              hideText="true"
              colors={["#32CD32"]}
              needleColor="#32CD32"
              needleBaseColor="#32CD32"
            />
            <center>
              <Label className="p-gauge-orange">20%</Label>
            </center>
            <center className="p-bold-500 w3-small m-1">
              {t("gauge.placemnt_order") ||
                "Placement V/s Order"}
            </center>
          </Grid.Column>
          <Grid.Column>
            <GaugeChart
              id="gauge-chart3"
              textColor="black"
              nrOfLevels={35}
              percent={0.56}
              hideText="true"
              colors={["#78CA44"]}
              needleColor="#78CA44"
              needleBaseColor="#78CA44"
            />
            <center>
              <Label className="p-gauge-green">56%</Label>
            </center>
            <center className="p-bold-500 w3-small m-1">
              {t("gauge.placement_acceptance") ||
                "Placement V/s Acceptance"}
            </center>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </React.Fragment>
  );
};

export default translate("dashboard")(Gauge);
